import { useState } from "react";
import { FormattedMessage } from "react-intl";
import ClearIcon from '@mui/icons-material/Clear';
import { Box, CircularProgress, IconButton } from "@mui/material";
import CustomTextField from "../TextField";
import Folders from "./Folders";

const ClearButton = ({ onClick }) => (
  <IconButton
    edge="end"
    onClick={onClick}
    title={<FormattedMessage id="common.clear" />}
  >
    <ClearIcon />
  </IconButton>
);

const FolderSelector = ({ allowClear, initialFolderId, label, onChange, value }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openedNodes, setOpenedNodes] = useState([]);
  const [openFolders, setOpenFolders] = useState(false);

  const handleChange = (e, folder) => {
    e?.stopPropagation();
    onChange?.(folder);
    setOpenFolders(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange?.({ folderId: null, name: " " });
    setOpenFolders(false);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <CustomTextField
        defaultValue=" "
        endAdornment={allowClear && (
          <ClearButton onClick={handleClear} />
        )}
        label={(label === undefined) ? <FormattedMessage id="common.selectFolder" /> : label}
        onClick={() => setOpenFolders(true)}
        startAdornment={isLoading && (
          <CircularProgress color="inherit" size="1em" sx={{ verticalAlign: "middle" }} />
        )}
        sx={{
          "& > .MuiInputBase-root": {
            "& > .MuiInputBase-input": {
              cursor: "pointer"
            },
            cursor: "pointer"
          }
        }}
        value={isLoading ? " " : value.name}
      />
      <Folders
        initialFolderId={initialFolderId}
        onChange={handleChange}
        onClose={() => setOpenFolders(false)}
        onLoading={(loading) => setIsLoading(loading)}
        open={openFolders}
        openedNodes={openedNodes}
        setOpenedNodes={setOpenedNodes}
      />
    </Box>
  );
};

export default FolderSelector;
